<template>
  <Layout>
    <div class="row app-user-avatar">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="flex-center" style="width:100%;height:100%;">
              <div style="width:600px;min-height:70vh;padding-top:10vh">
                <t-form>
                  <t-form-item label="用户名">{{ name }}</t-form-item>
                  <!-- <t-form-item label="手机号">{{ user.phone }}</t-form-item> -->
                  <t-form-item label="手机号"
                    ><t-input v-model="phone" placeholder="请输入"> </t-input
                  ></t-form-item>
                  <t-form-item label="新密码"
                    ><t-input
                      v-model="password"
                      type="password"
                      placeholder="非必填，最低8位，至少1大写字母、1小写字母、1数字、1英文符号"
                      :status="passwordStatus"
                      :tips="passwordTips"
                      @change="checkPassword"
                    />
                  </t-form-item>
                  <t-form-item label="确认密码"
                    ><t-input
                      v-model="password_two"
                      type="password"
                      placeholder="请输入确认密码"
                      :status="password2Status"
                      :tips="password2Tips"
                      @change="checkRepeatPassword"
                    />
                  </t-form-item>
                  <t-form-item label="验证码">
                    <div style="position: relative; width: 100%">
                      <t-input v-model="code" placeholder="请输入"></t-input>
                      <t-button
                        variant="text"
                        theme="primary"
                        class="getCode"
                        :disabled="flagBtn"
                        @click="getPhoneCode"
                      >
                        <span v-if="!flagBtn">获取验证码</span>
                        <span v-else>{{ codeTime }}s后重新获取</span>
                      </t-button>
                    </div>
                  </t-form-item>
                </t-form>
                <div
                  style="padding-left:100px;margin-top:30px;margin-bottom:20px;position:relative;width:100%;height:40px;display:flex;justify-content:center"
                >
                  <button
                    class="btn-sm btn btn-primary"
                    style="width:100%"
                    type="button"
                    @click="save"
                  >
                    保存
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import user from "../../../server/api/user";
import auth from "../../../server/api/auth";
import ImageUpload from "../../../components/imageUpload.vue";
import { getTimeNow, passwordValidate } from "@/util/fun.js";

export default {
  components: {
    Layout,
    ImageUpload,
  },
  data() {
    return {
      power: "",
      name: "",
      avatar: "",
      password: "",
      password_two: "",
      code: "",
      phone: "",
      user: { avatar: "" },
      flagBtn: false,
      codeTime: 29,
      params: {
        userType: 1,
        noShowLoading: false,
      },
      passwordStatus: "default",
      passwordTips: "",
      password2Status: "default",
      password2Tips: "",
    };
  },

  mounted() {
    this.power = this.utils.currentPower("创作平台-用户中心");
    // // 获取详情
    this.user = JSON.parse(this.cookies.getCookie("user"));
    this.name = this.user.username;
    this.phone = this.user.phone;
    // console.log("用户信息", this.user);
    // this.getUserInfo();
    // if (this.$route.query.id) {
    //   this.index_id = this.$route.query.id;
    //   this.fetch()
    // }
  },

  methods: {
    getUserInfo() {
      auth.userInfo(this.params).then((resp) => {
        console.log("用户信息", resp);
        if (resp.data) {
          //   this.$refs.image.setImageUrl(resp.data.avatar);
          //   this.cookies.setCookie("user", JSON.stringify(resp.data));
        }
      });
    },
    getPhoneCode() {
      let params = {
        phone: this.user.phone,
      };
      user.sendMsg(params).then((res) => {
        if (res.code === 0) {
          this.success("发送成功");
          this.flagBtn = true;
          // setTimeout(() => {
          //   this.flagBtn = false;
          // }, 30000);
          let codeInterval = window.setInterval(() => {
            if (this.codeTime-- <= 0) {
              this.codeTime = 29;
              this.flagBtn = false;
              window.clearInterval(codeInterval);
            }
          }, 1000);
        } else {
          this.warning(res.msg);
        }
      });
    },
    save() {
      let params = {
        adminId: this.user.id,
      };
      if (!this.phone) {
        this.info("手机号未填写");
        return;
      }
      if (this.phone == this.user.phone && !this.password) {
        this.info("没有要修改的内容");
        return;
      }
      if (this.phone) {
        var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!myreg.test(this.phone)) {
          this.info("新手机号格式不正确");
          return;
        }
        params.phone = this.phone;
      }
      if (this.password) {
        if (
          !this.checkPassword(this.password) ||
          !this.checkRepeatPassword(this.password_two)
        ) {
          return;
        }
        params.newPassword = this.password;
      }
      if (!this.code) {
        this.info("请输入验证码");
        return;
      }
      params.verifyCode = this.code;
      if (params.newPassword) {
        params.lastChangeTime = getTimeNow(); //密码修改时间
      }
      auth.adminUpdate(params).then((res) => {
        console.log("修改结果", res);
        if (res.code === 0) {
          this.success("修改成功");
          this.cookies.clearCookie("token");
          this.cookies.clearCookie("user");
          this.cookies.clearCookie("userList");
          setTimeout(() => {
            this.$router.push({
              name: "login",
            });
          }, 2000);
        } else {
          this.warning(res.msg);
        }
      });
    },
    checkPassword(str) {
      let result = passwordValidate(str, 8);
      if (!result) {
        this.passwordTips =
          "最低8位，至少1大写字母、1小写字母、1数字、1英文符号";
        this.passwordStatus = "error";
        return false;
      } else {
        this.passwordTips = "";
        this.passwordStatus = "default";
        return true;
      }
    },
    checkRepeatPassword(str) {
      if (!str) {
        this.password2Tips = "请输入确认密码";
        this.password2Status = "error";
      } else if (str != this.password) {
        this.password2Tips = "密码不一致";
        this.password2Status = "error";
      } else {
        this.password2Tips = "";
        this.password2Status = "default";
        return true;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.getCode {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 100;
}
.app-user-avatar .app-image-upload .avatar-uploader .el-upload {
  border-radius: 50%;
}
.app-user-avatar .submit-bar {
  text-align: center;
}

.app-user-avatar .submit-bar .bar-handle {
  display: inline-block;
  float: inherit;
}

.app-user-avatar .submit-bar .bar-handle button {
  margin-left: 0;
}

.app-user-avatar .app-image-upload {
  display: inline-block;
}
</style>
